module.exports = "/_next/static/images/OnboardingDesktop-e98db61256440b0fd9f8289766eb6063.webp";